import { ArrowLeftOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import { Alert, Button, Spin } from "antd";
import axios from "axios";
import qs from "query-string";
import React, { useState } from "react";
import { UNKNOWN_ERROR_MESSAGE } from "../constants";
import { persistLinkState } from "../hooks/useLinkTracker";
import { captureException } from "../sentry";
import Store from "../stateStore";
import { extractLinkParamsFromState, getBackendUrl, STORES } from "../utils";

type Props = {
  clientSecret: string;
  onBack: () => any;
  onCancel: () => any;
  onComplete: any;
};

function Magento(props: Props) {
  const { onComplete, clientSecret } = props;

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const store = Store.useStore();
  const isSandbox = store.get("isSandbox");
  const orgName = store.get("orgName");
  const organizationId = store.get("orgId");
  const nonce = store.get("nonce");
  const origin = store.get("origin");
  const autoPlatform = store.get("autoPlatform");

  const isUpdate = store.get("isUpdate");
  const itemId = store.get("itemId");

  const handleAuthError = (e: any) => {
    captureException(e);
    if (e.response?.data?.error_message) {
      setError(e.response.data?.error_message);
    } else {
      setError(UNKNOWN_ERROR_MESSAGE);
    }
  };
  React.useEffect(() => {
    handleComplete();
  }, []);
  const handleComplete = () => {
    // redirect to oauth
    setLoading(true);
    persistLinkState(STORES.SQUARESPACE, store.getState());
    const q = qs.stringify({
      ...extractLinkParamsFromState(store),
    });
    const url = `${getBackendUrl()}/oauth/squarespace_initiate?${q}`;
    window.location.replace(url);
  };

  const handleFakeComplete = () => {
    setLoading(true);
    axios
      .post(`${getBackendUrl()}/link/token/fulfill`, {
        type: STORES.SQUARESPACE,
        clientId: clientSecret,
        username: "user_good",
        password: "pass_good",
      })
      .then((response) => {
        const { data } = response;
        const { public_token } = data;
        onComplete(public_token);
      })
      .catch(handleAuthError)
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 99,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spin></Spin>
    </div>
  );

  return (
    <div style={{ padding: "1.6rem" }}>
      {!autoPlatform && (
        <div style={{ display: "flex" }} className="">
          <Button
            onClick={props.onBack}
            icon={<ArrowLeftOutlined />}
            className="flex items-center"
          >
            Back
          </Button>
        </div>
      )}
      <div
        className="flex items-center flex-column mt-4"
        style={{ justifyContent: "center", paddingBottom: "20px" }}
      >
        <img
          style={{ height: "80px" }}
          src="https://rutterpublicimages.s3.us-east-2.amazonaws.com/logos/squarespace-logo.png"
          alt=""
        />
      </div>
      {/* <div className="font-semibold">Username</div>
      <div style={{ marginBottom: 16 }} className="mt-2">
        <Input
          placeholder="Store URL"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </div>
      <div className="font-semibold">Password</div>
      <div style={{ marginBottom: 16 }} className="mt-2">
        <Input
          placeholder="Store URL"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
        />
      </div> */}

      {isSandbox ? (
        <Button
          type="primary"
          block
          disabled={loading}
          onClick={handleFakeComplete}
        >
          {loading ? "Connecting..." : "Sandbox: Connect Test Squarespace"}
        </Button>
      ) : (
        <Button
          type="primary"
          block
          disabled={loading}
          onClick={handleComplete}
        >
          {loading ? "Connecting..." : "Connect Squarespace"}
        </Button>
      )}
      {error && (
        <Alert
          className="mt-4"
          type="error"
          message={"Error"}
          description={error}
          showIcon
        ></Alert>
      )}
    </div>
  );
}

export default Magento;

const Container = styled.div``;
